export default (extensionJoints, eventName, value) =>
    extensionJoints.map(extensionJoint =>
        extensionJoint.getExtension().getEventListener(eventName)(value)
    );



// WEBPACK FOOTER //
// ./src/compose/syncList.js